'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = currentlyEditing;

var _selectionConstants = require('../../../common/elements/selectionConstants');

var SELECTION_ACTION_TYPES = _interopRequireWildcard(_selectionConstants);

var _draggingConstants = require('../../reducers/draggingConstants');

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = Immutable.fromJS({
    id: null
});

/**
 * When an element is selected, check if it's the same element that's being edited, otherwise stop editing.
 */
var handleElementSelect = function handleElementSelect(state, action) {
    var currentlyEditingId = state.get('id');
    return currentlyEditingId && action.ids.length === 1 && action.ids.indexOf(currentlyEditingId) !== -1 ? state : initialState;
};

function currentlyEditing() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case SELECTION_ACTION_TYPES.ELEMENT_EDIT_START:
            return state.merge({
                id: action.id,
                editorKey: action.editorKey
            });
        case SELECTION_ACTION_TYPES.ELEMENT_SET_EDIT_HANDLER:
            return state.merge({
                id: action.id,
                editorKey: action.editorKey
            });
        case SELECTION_ACTION_TYPES.ELEMENT_EDIT_COMPLETE:
            return initialState;
        case SELECTION_ACTION_TYPES.ELEMENTS_SELECTED:
            return handleElementSelect(state, action);
        case _draggingConstants.DRAG_START:
            return initialState;
        default:
            return state;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/client/element/selection/currentlyEditingReducer.js
// module id = 2024
// module chunks = 0